/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Created_Step_2Inputs */



/**
* | output |
* | --- |
* | "They open it, or paste the code in Team > Import." |
*
* @param {Team_Share_Created_Step_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_created_step_2 = /** @type {((inputs?: Team_Share_Created_Step_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Created_Step_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("They open it, or paste the code in Team > Import.")
	if (locale === "de") return /** @type {LocalizedString} */ ("They open it, or paste the code in Team > Import.")
	if (locale === "it") return /** @type {LocalizedString} */ ("They open it, or paste the code in Team > Import.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("They open it, or paste the code in Team > Import.")
	if (locale === "es") return /** @type {LocalizedString} */ ("They open it, or paste the code in Team > Import.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("They open it, or paste the code in Team > Import.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("They open it, or paste the code in Team > Import.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("They open it, or paste the code in Team > Import.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("They open it, or paste the code in Team > Import.")
	return /** @type {LocalizedString} */ ("They open it, or paste the code in Team > Import.")
});